export const LOAD_DELIV_PRODUTOS = "LOAD_DELIV_PRODUTOS";
export const SET_PAGE_DELIV_PRODUTO = "SET_PAGE_DELIV_PRODUTO";
export const SET_PERPAGE_DELIV_PRODUTO = "SET_PERPAGE_DELIV_PRODUTO";
export const SET_TOTAL_DELIV_PRODUTO = "SET_TOTAL_DELIV_PRODUTO";
export const SET_DELIV_PRODUTO = "SET_DELIV_PRODUTO";
export const LOADING_DELIV_PRODUTO = "LOADING_DELIV_PRODUTO";
export const SET_FILTRO_DELIV_PRODUTO = "SET_FILTRO_DELIV_PRODUTO";

export const LOAD_DELIVE_PRODUTO_COMPLEMENTOS =
  "LOAD_DELIVE_PRODUTO_COMPLEMENTOS";
export const SET_PAGE_DELIV_CATEGORIA = "SET_PAGE_DELIV_CATEGORIA";
export const SET_PERPAGE_DELIV_CATEGORIA = "SET_PERPAGE_DELIV_CATEGORIA";
export const SET_TOTAL_DELIV_CATEGORIA = "SET_TOTAL_DELIV_CATEGORIA";
export const LOAD_DELIV_CATEGORIAS = "LOAD_DELIV_CATEGORIAS";

export const LOAD_COMPLEMENTOS = "LOAD_COMPLEMENTOS";
export const SET_PAGE_COMPLEMENTO = "SET_PAGE_COMPLEMENTO";
export const SET_PERPAGE_COMPLEMENTO = "SET_PERPAGE_COMPLEMENTO";
export const SET_TOTAL_COMPLEMENTO = "SET_TOTAL_COMPLEMENTO";
export const SET_CONTROLAR_ESTOQUE = "SET_CONTROLAR_ESTOQUE";
export const LOADING_COMPLEMENTO = "LOADING_COMPLEMENTO";
export const SET_FILTRO_COMPLEMENTO = "SET_FILTRO_COMPLEMENTO";

export const SET_IMAGENS_PRODUTO = "IMAGENS_PRODUTO";
